import registry from './remainingModelLayers.json';
import {canonicalSlug} from './catalog';
import {photographicBandScene,pepinBandWindows} from './photographicBands';

// Cart and configurator consume the same immutable photographed sources.
// Default bands only express the historical Miel/Rose of a legacy Pépin;
// they never add choices to a saved order or replace an unknown explicit ID.
export function remainingModelScene({slug:rawSlug,front,middle,bottom,back,ribbonFabric,view='front'}) {
  const slug=canonicalSlug(rawSlug),library=registry.models[slug];
  if(!library||!['front','back'].includes(view))return null;
  const ribbonId=ribbonFabric?.option_id||library.defaults.ribbon;
  if(slug==='pepin-le-sorbet'&&view==='front')return photographicBandScene({
    library:{...library,colours:library.front,windows:pepinBandWindows},
    top:front||{option_id:library.defaults.front},
    middle:middle||{option_id:library.defaults.middle},
    bottom:bottom||{option_id:library.defaults.bottom},
    ribbonFabric:{option_id:ribbonId},
  });
  const bodyId=(view==='front'?front:back)?.option_id||library.defaults[view];
  const body=library[view][bodyId],ribbon=library.ribbons[ribbonId];
  if(!body?.src||!ribbon?.src)return null;
  const scene={body:body.src,bodyId,ribbon:ribbon.src,ribbonId,
    bodyPlacement:{...library.bodyPlacement},
    ribbonPlacement:{...library.ribbonPlacement,...ribbon.placement}};
  // The stick is not a configurable colour: reuse the exact photographed
  // beige stick on the back too, even if a generated fabric source changed it.
  if(slug==='pepin-le-sorbet'&&view==='back'){
    scene.bodyMask=library.master.src;
    scene.bodyPanels=[
      {id:'back',src:body.src,clipPath:'inset(0 0 25.8% 0)'},
      {id:'stick',src:library.master.src,clipPath:pepinBandWindows.stick},
    ];
  }
  return scene;
}
